export const modals = {
	confirmProductToggle: {
		deactivateProduct: "Deactivate product",
		activateProduct: "Activate product",
		confirmModalDescription:
			"Do you want to {{action}} the mountable products it comprises?",
	},
	confirmToggle: {
		deactivateProduct: "Deactivate product",
		activateProduct: "Activate product",
		toggleProducts: "Toggle only this product",
	},
	deleteCategory: {
		title: "Delete category",
		cancelButton: "Cancel",
		moveAndDeleteButton: "Move products and delete category",
		deleteButton: "Delete category",
		newCategoryLabel: "New category",
		selectNewCategoryPlaceholder: "Select new category",
		categoryDeletedSuccess:
			'The category "{{categoryName}}" has been successfully deleted.',
		categoryDeletedAndProductsMovedSuccess:
			'The category "{{categoryName}}" has been deleted and its products have been moved to ' +
			'"{{newCategoryName}}".',
		categoryWithProductsDescription:
			"This category has <strong>{{productCount}} linked product</0>. " +
			"Before deleting the category you need to move the products to another category",
		categoryWithProductsDescription_plural:
			"This category has <strong>{{productCount}} linked products</0>. " +
			"Before deleting the category you need to move the products to another category",
		confirmDeleteCategoryDescription:
			"Are you sure you want to delete this category? <strong>This action cannot be undone.</0>",
	},
	massEdit: {
		title: "Mass product editing",
		completeButton: "Complete",
		cancelButton: "Cancel",
		comingSoon: "Coming soon: mass editing flow",
		selectedCount: "{{count}} {{unit}} selected",
		selectedCount_plural: "{{count}} {{unit}} selected",
		selectedProduct: "Selected product",
		selectedProducts: "Selected products",
		instruction: 'Click "Complete" to proceed with category deletion.',
		fields: {
			category: {
				label: "Category",
				placeholder: "Choose the new category",
			},
			type: {
				label: "Type",
				placeholder: "Choose a new type",
			},
			fiscalGroup: {
				label: "Fiscal group",
				placeholder: "Choose a new fiscal group",
			},
			fiscalProfile: {
				label: "Fiscal profile",
				placeholder: "Choose a new fiscal profile",
			},
		},
	},
	duplicateProductDrawer: {
		title: "Duplicate mountable product",
		stepTitles: {
			duplicateProduct: "Duplicate Product",
			selectProducts: "Select Products",
		},
		duplicationChoice: {
			createNewProduct: {
				title: "Create new mountable product",
				description: "Duplicate the mountable to use in a new product",
			},
			batchDuplicate: {
				title: "Import duplicate in batch",
				description: "Import the mountable step to already created products",
			},
		},
		actions: {
			cancel: "Cancel",
			back: "Back",
			duplicate: "Duplicate mountable",
			addProducts: "Add products",
			comingSoon: "This functionality will be implemented soon",
			noMountableData: "No mountable data to duplicate",
		},
		productSelection: {
			label: "Select the products that will receive the mountable:",
			placeholder: "Select products...",
			selectedProducts: "Selected products",
			emptyState: {
				title: "No product selected",
				description: "Add the products you want to duplicate the mountable to",
			},
			successMessage:
				'Settings from "{{productName}}" were applied to {{count}} product successfully.',
			successMessage_plural:
				'Settings from "{{productName}}" were applied to {{count}} products successfully.',
		},
	},
	deleteProduct: {
		cancel: "Cancel",
		delete: "Delete",
		confirmDeleteMessage:
			'Are you sure you want to delete the product <strong>"{{productName}}"</strong>?',
	},
	deleteProducts: {
		title: "Delete selected products {{count}}",
		cancelButton: "Cancel",
		deleteButton: "Delete product",
		deleteButton_plural: "Delete {{count}} products",
		description:
			"The {{count}} selected products will be deleted from this location and this action cannot be " +
			"undone (you can view them at the org level).",
		confirmQuestion: "Are you sure you want to continue?",
		deleteSuccess: "Product deleted successfully",
		deleteSuccess_plural: "{{count}} products deleted successfully",
	},
	exitMassEditMode: {
		title: "Exit mass edit mode?",
		description:
			"You have selected products. When navigating to another category, the selection will be lost.",
		confirmButton: "Yes, exit",
		cancelButton: "Cancel",
	},
};
